import React from 'react';
import {Box} from "@mui/material";
import {Theme, styled} from "@mui/system";
import {WarningLevelType} from '../types/WarningLevelType';

const Root = styled(Box, {
  shouldForwardProp: (prop) => (
    prop !== 'expanded' && prop !== 'warningLevel'
  )
})(({theme, warningLevel, expanded}: {
  theme: Theme,
  warningLevel?: WarningLevelType,
  expanded?: boolean
}) => ({
  marginBottom: theme.spacing(2),
  boxShadow: '0px 1px 3px 0px #0000001F',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: (warningLevel && warningLevel !== 'none') ? theme.palette[warningLevel].light : "#f5f5f5",
  overflow: 'auto',
  wordWrap: 'break-word',
  [theme.breakpoints.up('sm')]: {
    overflow: 'hidden',
  },
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: expanded ? 'flex-start' : 'center',
}));

type CollapsableCardContainerWarningAdditionalProps = React.ComponentPropsWithoutRef<'div'> & {
  theme?: Theme,
  warningLevel?: WarningLevelType,
  expanded?: boolean
}

/**
 * MUI Box component styled in the SecurSpace way. Used as the main container when creating a Collapsable Card
 * @param children children passed through to the internal Grid component
 * @param warningLevel tells the container which background color to use
 * @param expanded tells the container whether the card is collapsed or not
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CollapsableCardContainerWarning = ({ children, ...rest}: CollapsableCardContainerWarningAdditionalProps) => {
  return <Root {...rest}>
    { children }
  </Root>
}

export { CollapsableCardContainerWarning };
